import { Box, StepLabel, Step, Stepper, Fade, styled } from '@mui/material';

import { RegistrationStep } from '../constants/steps.js';
import { useRegistration } from '../contexts/RegistrationContext.js';

import { FONT_FAMILY } from './shared/index.js';
import Access from './steps/Access.js';
import ConfirmationCode from './steps/ConfirmationCode.js';
import Password from './steps/Password.js';
import UserInfo from './steps/UserInfo.js';

const STEPS = [
  { label: 'Details', component: UserInfo, step: RegistrationStep.USER_INFO },
  {
    label: 'Access',
    component: Access,
    step: RegistrationStep.ACCESS,
  },
  { label: 'Password', component: Password, step: RegistrationStep.PASSWORD },
  {
    label: 'Confirmation',
    component: ConfirmationCode,
    step: RegistrationStep.CONFIRMATION_CODE,
  },
] as const;

const StyledStepper = styled(Stepper)({
  marginBottom: 24,
  '& div': {
    padding: 0,
  },
  '& .MuiStepLabel-label': {
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.1px',
    fontFamily: FONT_FAMILY,
  },
  '& .MuiStepLabel-label.Mui-active': {
    fontWeight: 700,
  },
});

const StepContent = styled(Box)({
  minHeight: 280,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
});

const RegistrationStepper = () => {
  const { currentStep, isLoading, completedSteps } = useRegistration();
  const activeStepIndex = STEPS.findIndex(({ step }) => step === currentStep);
  const ActiveComponent = STEPS.find(({ step }) => step === currentStep)?.component ?? UserInfo;

  return (
    <Box sx={{ width: '100%' }}>
      <StyledStepper alternativeLabel activeStep={activeStepIndex}>
        {STEPS.map((step) => (
          <Step key={step.label} completed={completedSteps.includes(step.step)}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </StyledStepper>

      <StepContent>
        <Fade in={!isLoading} timeout={300}>
          <Box sx={{ flex: 1 }}>
            <ActiveComponent />
          </Box>
        </Fade>
      </StepContent>
    </Box>
  );
};

export default RegistrationStepper;
